import { version } from "./version";

export const environment = {
  URL_WEB:"https://web.dev.liberasoft.cloud/",
  production: false,
  apiUrl:"https://api.dev.liberasoft.cloud/b2b/",
  filesUrl:"https://api.dev.liberasoft.cloud/files/",
  dateBuild: version.dateBuild,
  Version: version.Version,
  MODE:"B2B"
};
